import Select, { DropdownIndicatorProps, OptionsOrGroups, PlaceholderProps, components } from "react-select";

type Props = {
    id?: string,
    className?: string,
    name: string,
    placeholder?: string,
    options: OptionsOrGroups<any, any>,
    defaultValue?: any,
    value?: any,
    onChange: (event: any) => Promise<void>,
    onBlur?: () => void,
    disabled?: boolean
}

export default function CustomSelect(props: Props) {
    const { id, className, name, options, defaultValue, placeholder, value, disabled, onChange, onBlur } = props;

    const Placeholder = (props: PlaceholderProps) => {
        return <components.Placeholder {...props} />;
    };

    const DropdownIndicator = (props: DropdownIndicatorProps) => {
        return (
            <components.DropdownIndicator {...props}>
                <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.95853 10.6745L13.0349 2.21619C13.4658 1.49806 12.9446 0.577604 12.0774 0.577604L1.9248 0.577604C1.05768 0.577604 0.536395 1.49806 0.967389 2.21619L6.04371 10.6745C6.47295 11.3897 7.52929 11.3897 7.95853 10.6745Z" fill="#F9F9F9" />
                </svg>
            </components.DropdownIndicator>
        );
    };

    return <Select
        id={id}
        className={className}
        options={options}
        name={name}
        defaultValue={defaultValue}
        placeholder={placeholder}
        value={value}
        isDisabled={disabled}
        onBlur={onBlur}
        components={{ Placeholder, DropdownIndicator, IndicatorSeparator: () => null }}
        styles={{
            control: styles => ({
                ...styles,
                minWidth: '129px',
                minHeight: '26px',
                borderRadius: '0',
            }),
            indicatorsContainer: styles => ({
                ...styles,
                backgroundColor: '#E63F4B',
                minWidth: '22px',
                minHeight: '22px',
                alignSelf: 'center',
                marginLeft: '3px',
                marginRight: '3px',
            }),
            placeholder: styles => ({
                ...styles,
                textOverflow: "ellipsis",
                maxWidth: "90%",
                whiteSpace: "nowrap",
                overflow: "hidden"
            })
        }}
        onChange={async (option: OptionsOrGroups<any, any>,) => {
            // console.error(option)
            await onChange(option);
        }}
    />
}